import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import "./BadgeCircle.scss";
import { cleanJoin } from "../../utils/stringUtil";

function BadgeCircle({
  size = 2,
  icon,
  iconBulmaColor = "black",
  iconColor = "danger",
  iconSize = 2,
  textBulmaColor = "black",
  children,
  className,
  value,
  ...rest
}) {
  const [textSize, setTextSize] = useState(0);

  useEffect(() => {
    value.toString().length >= 1 && value.toString().length < 5 ? setTextSize(4) : setTextSize(5);
  }, [value]);

  return (
    <span {...rest} className={cleanJoin("badgeCircle", className)}>
      {children ? (
        <span>{children}</span>
      ) : icon ? (
        <FontAwesomeIcon size={`${iconSize}x`} className={`has-text-${iconColor}`} icon={icon} />
      ) : (
        <></>
      )}
      <span
        style={{ width: "80px" }}
        className={cleanJoin(
          "tag",
          `is-size-${textSize}`,
          `is-bv${size}`,
          `has-text-${textBulmaColor}`
        )}
      >
        {value}
      </span>
    </span>
  );
}

export default BadgeCircle;
